export default {
  discover: {
    title: 'Sign up for Starts at 60 now',
    shortTitle: 'Stories that matter',
    description:
      'Starts at 60 is home to the largest community of over-60s in Australia. Our mission is to help you help yourself amid Covid-19 and beyond, with trustworthy information, expert advice, useful offers and community conversations.',
    shortDescription: 'Emails delivered daily',
    imageURL:
      'http://images.startsat60.com/wp-content/uploads/20181210153853/hero-bg-stories.jpg',
    list: 'daily_sas',
  },
};
